import { css } from "@emotion/react"
import styled from "@emotion/styled"
import icon from "./TakePhoto.svg"
import { theme } from "@/theme"

const Icon = styled.div`
    position: relative;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.palette.intentions.primary.main};
    border-radius: 50%;
    flex-shrink: 0;
`

export const TakePhotoIcon = () => {
    return (
        <Icon>
            <img
                src={icon}
                css={css`
                    width: 28px;
                    height: 28px;
                    pointer-events: none;
                    transform: translate(-1px, -1px);
                `}
            />
        </Icon>
    )
}
